import { createAsyncThunk } from "@reduxjs/toolkit";
import { OnboardingNetworkService } from "./OnboardingNetworkService";


export class OnboardingActions {
  //* GET ALL TEMPLATES LIST
  // static getOnboardingConfig = createAsyncThunk(
  //   "LiveChatSlice/getOnboardingConfig",
  //   (data: any, { dispatch, rejectWithValue }: any) => {
  //     return OnboardingNetworkService.getOnboardingConfig(data)
  //       .then((response: any) => {
  //         return response;
  //       })
  //       .catch((error: { response: unknown }) => {
  //         return rejectWithValue(error?.response);
  //       })
  //       .finally(() => { });
  //   }
  // );

  static  updateWhatsappProfile = createAsyncThunk(
      "OnboardingSlice/updateWhatsappProfile",
      (data: any,{dispatch, rejectWithValue}) => {
        return OnboardingNetworkService.updateWhatsappProfile(data)
        .then(async (response: any) => {
          return response;
        })
          .catch((err: { response: unknown }) => { return rejectWithValue(err?.response);})
          .finally(() => {});
      },
    );
 

}
